import { Component } from '@angular/core';
import { ModalService } from 'src/app/services/modal/modal.service';
import { ModalContentKey } from 'src/app/utils/enums';

@Component({
	selector: 'app-exit-banner',
	templateUrl: './exit-banner.component.html',
	styleUrls: ['./exit-banner.component.scss'],
})
export class ExitBannerComponent {
	constructor(private readonly modalService: ModalService) {}

	onExitSimulator() {
		this.modalService.openGenericModal(ModalContentKey.ABANDON_MODAL);
	}
}
